
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

import { FinancialInvoice } from '@/domains/global/models'
import InvoiceStatusPill from './StatusPill.vue'

@Component({
  components: { InvoiceStatusPill }
})
export default class InvoiceSegment extends Vue {
  @Prop({ type: Object as () => FinancialInvoice, required: true })
  readonly invoice!: FinancialInvoice

  get name() {
    switch (this.invoice.type) {
      case 'correction':
        return 'Correction Invoice'
      default:
        return 'Job Invoice'
    }
  }

  get title() {
    const parts = [`${this.name}`]
    if (this.invoice.status === 'paid') {
      parts.push(`(${this.invoice.invoiceNumber})`)
    }
    return parts.join(' ')
  }

  openInvoice() {
    this.$router.push({ name: 'customer-invoices-read', params: { id: this.invoice.id?.toString() || '' } })
  }

  invoiceDiscount(invoice: any) {
    if (!invoice.total_discount_amounts?.length) {
      return 0
    }
    let totalInvoiceDiscount = 0
    for (const discount of invoice.total_discount_amounts) {
      totalInvoiceDiscount += discount.amount
    }
    return totalInvoiceDiscount
  }
}
